<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'app.about_app' | translate }}
    v-card-content
      .app-info__logo
        i.i-header-logo.mr-1
        .app-info__logo-title PROFEED
      .app-info__item
        .app-info__item-label {{ 'app.version' | translate }}
        .app-info__item-value {{ appVersion}}
      .app-info__item
        .app-info__item-label {{ 'app.updated' | translate }}
        .app-info__item-value {{ updateDate }}
    v-card-actions(center)
      v-btn(
        @click="$emit('close')") {{ 'base.close' | translate }}
</template>

<script>
import { name } from '../../../../../package.json'

export default {
  name: 'AppInfo',

  computed: {
    appName () {
      return name
    },

    appVersion () {
      return process.env.VUE_APP_VERSION
    },

    updateDate () {
      return process.env.VUE_APP_UPDATE_DATE
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';

  .app-info {
    &__logo {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 3rem 0 4rem 0;

      &-title {
        font-size: 3rem;
        font-weight: bold;
        font-family: 'RoadRadio', sans-serif;
      }
    }

    &__item {
      display: flex;
      justify-content: space-between;

      &:not(:last-child) {
        margin-bottom: 1.2rem;
      }

      &-label {
        color: $color-gray;
        font-size: 1.5rem;
      }

      &-value {
        font-size: 1.5rem;
      }
    }
  }
</style>
